module.exports = __webpack_public_path__ + "assets/img/program_head.2e81f7c4.png";